import React from "react";
import { Translate } from "react-localize-redux";
import Select from "react-select-me";
import "./style.sass";

import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import "react-select-me/lib/ReactSelectMe.css";

const PaymentSelect = ({ options, value, handleSelect }) => {
	const handleItemClick = (value) => {
		handleSelect(value);
	};
	const selectRef = React.useRef();

	const handleOpen = () => {
		if (selectRef?.current) {
			selectRef.current.style.zIndex = "9999";
		}
	};

	const handleClose = () => {
		if (selectRef?.current) {
			selectRef.current.style.zIndex = "";
		}
	};

	const classNames = {
		dd__wrapper: "selector-wrapper",
		dd__selectControl: "selector-control",
		dd__selected: "selector-selected",
		dd__selectedItem: "selector-selected-item",
		dd__openTobottom: "selector-open-bottom",
		dd__list: "selector-list",
		dd__option: "selector-option",
		dd__openTotop: "selector-opentotop",
		dd__placeholder: "selector-placeholder",
	};

	const optionRenderer = (option) => {
		return <div className="selector-option">{option.label}</div>;
	};

	const iconRenderer = (isOpened) => {
		return isOpened ? (
			<ArrowDownIcon style={{ width: "18px", transform: "rotate(180deg)" }} />
		) : (
			<ArrowDownIcon style={{ width: "18px" }} />
		);
	};

	return (
		<Translate>
			{({ translate }) => (
				<div
					className="select-wrapper"
					ref={selectRef}>
					<Select
						key={value}
						placeholder={translate("SELECT")}
						onOpen={handleOpen}
						onClose={handleClose}
						value={value ? options.find((e) => e.value === value).label : undefined}
						className="selector-wrapper"
						options={options.filter((e) => e.value !== 0)}
						s={classNames}
						onChange={handleItemClick}
						iconRenderer={iconRenderer}
						optionRenderer={optionRenderer}
					/>
				</div>
			)}
		</Translate>
	);
};
export default PaymentSelect;
